<template>
  <div>
    <div
        v-for="item in items"
        :key="item.id"
        class="border-bottom border-right border-left">
      <div class="row">
        <div class="col-2 py-3">
          <div class="pl-4 text-nowrap">
            {{item.createdBy}}
          </div>

          <div class="pl-4 text-nowrap">
            {{formatDate(item.date, 'd.m.y')}}
          </div>
        </div>

        <div
            class="col-10 pointer"
            @click="$emit('select', item.id)">
          <div class="px-2 py-2">
            {{item.text}}
          </div>

          <div
              v-if="item.note"
              class="px-2 pt-2 pb-5 border-top">
            <i>{{item.note}}</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formatDate from '../../../../utils/formatDate';

export default {
  name: 'ClientConclusionAnamnesisList',

  props: ['items'],

  methods: {
    formatDate(date, format) {
      return formatDate(date, format);
    }
  },
};
</script>
